'use strict';

const STROKE = {
  color: '#27ae61',
  weight: 2,
  opacity: '1.0'
};
const FILL = {
  opacity: '0'
};
const DEFAULT_ZOOM = 12;

const ORDERS = {
  descricao: 'Alfabética',
  '-update': 'Atualização'
};

const MAP_STYLES = [
  {
    featureType: 'all',
    stylers: [
      { saturation: -100 },
      { hue: '#96a8cd' }
    ]
  }
];

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('MainCtrl', function($scope, $timeout, $rootScope,
  LoadingService, MessagesService, HistoricosService, VisitaCampoService, $route, $uibModal, $location) {
  $scope.maxPropriedadesMaps = 20;

  $scope.filter = {
    order: {
      field: 'descricao',
      descricao: ORDERS.descricao
    }
  };

  const loadHistoricos = function() {
    return HistoricosService.list().then(function(historicos) {
      $scope.historicos = historicos.data.reduce(function(result, historico) {
        result[historico.propriedade] = historico;
        return result;
      }, {});
    }, function() {
      MessagesService.alert('Falha ao carregar notificações.');
    });
  };

  // eslint-disable-next-line complexity
  const restorePropriedadeFromRedirect = function() {
    const redirectTo = $location.search().redirectTo;
    if (!redirectTo || $rootScope.currentPropriedade) {
      return false;
    }
    try {
      const storedPropriedadeRaw = localStorage.getItem(KEY_CURRENT_PROPRIEDADE);
      const storedPropriedade = storedPropriedadeRaw && JSON.parse(storedPropriedadeRaw);
      const found = storedPropriedade && $rootScope.getPropriedade(storedPropriedade.id);
      if (found && found.id) {
        $rootScope.currentPropriedade = found;
        LoadingService.hideLoading();
        $location.url(redirectTo);
        return true;
      }
    } catch (error) {
      console.error('Erro ao restaurar propriedade do localStorage', error);
    }
    return false;
  };

  $rootScope.bodyClass = 'bg-selecao-propriedades';

  /* ATTENTION: JQUERY BLOCK :( */
  const adjustHeight = function() {
    const CARD_HEIGHT = 190;
    const TOP_COMPENSATION = 50;
    $('[data-max-heigth]').each(function() {
      let top = $(this).parents('.panel:first')
        .offset().top;
      if ($(this).prev('.panel-footer').length > 0) {
        top = $(this).prev('.panel-footer')
          .offset().top;
      }
      const result = $(window).height() - top - TOP_COMPENSATION;
      $(this).css('max-height', Math.max(CARD_HEIGHT, result));
    });
  };
  const finish = function() {
    adjustHeight();
    LoadingService.hideLoading();
    $timeout(function() {
      $scope.animated = true;
    }, 1000);
  };
  $(window).resize(adjustHeight);

  // eslint-disable-next-line max-lines-per-function
  $scope.init = function() {
    LoadingService.showLoading();

    // eslint-disable-next-line max-lines-per-function
    $rootScope.initialize.then(function(result) {
      $scope.propriedades = result.propriedades;

      if (restorePropriedadeFromRedirect()) {
        return;
      }

      // eslint-disable-next-line max-lines-per-function
      function initMaps() {
        for (let i = $scope.propriedades.length - 1; i >= 0; i--) {
          const propriedade = $scope.propriedades[i];

          propriedade.gMap = new google.maps.Map(document.getElementById(`map_${ propriedade.id}`), {
            center: { lat: -34.397, lng: 150.644 },
            zoom: DEFAULT_ZOOM,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            options: {
              scrollwheel: false,
              navigationControl: false,
              mapTypeControl: false,
              scaleControl: false,
              draggable: false,
              zoomControl: false,
              styles: MAP_STYLES
            }
          });

          const bounds = new google.maps.LatLngBounds();
          for (let j = propriedade.map.polygons.length - 1; j >= 0; j--) {
            const polygon = propriedade.map.polygons[j];

            // Centraliza com base na primeira gleba
            if (j === 0) {
              for (let k = polygon.path.length - 1; k >= 0; k--) {
                bounds.extend(new google.maps.LatLng(polygon.path[k].latitude, polygon.path[k].longitude));
              }
            }

            // Construct the polygon.
            const coords = polygon.path.map(function(p) {
              return { lat: p.latitude, lng: p.longitude };
            });
            new google.maps.Polygon({
              paths: coords,
              strokeColor: STROKE.color,
              strokeOpacity: STROKE.opacity,
              strokeWeight: STROKE.weight,
              fillOpacity: FILL.opacity
            }).setMap(propriedade.gMap);
          }

          propriedade.gMap.setCenter({
            lat: bounds.getCenter().lat(),
            lng: bounds.getCenter().lng()
          });
        }

        /* TODO: Rever Timeout */
        finish();
      }

      /* TODO: Rever Timeout */
      loadHistoricos();
      if ($scope.propriedades.length < $scope.maxPropriedadesMaps) {
        $timeout(initMaps);
      } else {
        finish();
      }
    }, function(e) {
      if (e === 'MAPA') {
        MessagesService.alert('Ocorreu um problema ao carregar os mapas. Verifique sua conexão com a internet.');
      } else {
        MessagesService.alert('Falha ao carregar propriedades, tente novamente mais tarde.');
      }
      LoadingService.hideLoading();
    });
  };
  $scope.init();

  $scope.confirmRead = function(historico) {
    if (!historico) {
      return;
    }

    historico.nao_lidas = 0;
    HistoricosService.confirmRead(historico.propriedade);
  };

  $scope.showDetails = function(propriedade) {
    const finishShowDetails = function(data) {
      propriedade.alerts = data;
      propriedade.details = !propriedade.details;

      for (let i = $scope.propriedades.length - 1; i >= 0; i--) {
        $scope.propriedade = $scope.propriedades[i];
        if ($scope.propriedade.id !== propriedade.id) {
          $scope.propriedade.details = false;
        }
      }
    };

    if (propriedade.details) {
      finishShowDetails();
    } else {
      propriedade.alerts = null;
      propriedade.loadingDetails = true;
      VisitaCampoService.getGlebasAlerts({ propriedade: propriedade.id }).then(finishShowDetails, function() {
        MessagesService.alert('Falha ao carregar detalhes da propriedade.');
      })
        .finally(function() {
          propriedade.loadingDetails = false;
        });
    }
  };

  $scope.getHistoricos = function(historico) {
    historico.loading = true;
    HistoricosService.getHistoricos(historico.propriedade).then(function(result) {
      historico.historicos = result.data.historicos;
      $scope.confirmRead(historico);
    })
      .finally(function() {
        historico.loading = false;
      });
  };

  $scope.isShowPropriedade = function(descricao, term) {
    if ((term || '') === '') {
      return true;
    }

    return descricao.toUpperCase().indexOf(term.toUpperCase()) >= 0;
  };

  $scope.setOrder = function(event, order) {
    event.preventDefault();

    if (!$scope.propriedades[0].update) {
      for (let i = $scope.propriedades.length - 1; i >= 0; i--) {
        const propriedade = $scope.propriedades[i];
        if ($scope.historicos[propriedade.id].atualizado_data_hora) {
          propriedade.update = new Date($scope.historicos[propriedade.id].atualizado_data_hora);
        } else {
          propriedade.update = new Date(0); // Para aparecer por último
        }
      }
    }

    $scope.filter.order = {
      field: order,
      descricao: ORDERS[order]
    };
  };

  $scope.goToPropriedadeWithHistorico = function(propriedade, historico) {
    $rootScope.setPropriedade(propriedade);
    $timeout(function() {
      $route.updateParams({
        operacao: historico.tipo,
        date: moment(historico.created_at).format(MOMENT_DATE_ENGLISH_FORMAT),
        gleba: historico.gleba.id
      });
    });
  };

  $scope.goToPropriedadeWithAlerta = function(propriedade, alerta) {
    $rootScope.setPropriedade(propriedade);
    $timeout(function() {
      $route.updateParams({
        gleba: alerta.id,
        date: moment(alerta.ultima_acao).format(MOMENT_DATE_ENGLISH_FORMAT)
      });
    });
  };

  $scope.openUsageStatistics = function() {
    $uibModal.open({
      templateUrl: 'modal-usage-statistics.html'
    });
  };
});
